import { addMonetaryValues } from '../../../../utils/monetary-value-utils';
import { getOrderTip } from '../tips/get-order-tip';
import { getOrderBookingFee } from './get-order-booking-fee';
import { getOrderSubtotalPrice } from './get-order-subtotal-price';
/**
 * Gets the total price of the order.
 */
export const getOrderTotalPrice = () => {
    const subtotalCost = getOrderSubtotalPrice();
    const bookingFee = getOrderBookingFee(); // will be 0 if booking fee is not applicable.
    const tip = getOrderTip();
    return addMonetaryValues(subtotalCost, bookingFee, tip);
};
//# sourceMappingURL=get-order-total-price.js.map